import React, { useState, useEffect } from 'react';
import api from "../Api";
import Popup from "../components/PopUP";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import TableFooter from "../components/TableFooter";
import { useParams, Link } from "react-router-dom";

const UserDetails = () => {
  const { id } = useParams();
  const [userDetails, setUserDetails] = useState(null);
  const [popupMessage, setPopupMessage] = useState("Loading user details...");
  const [loading, setLoading] = useState(true);
  const [tokenSearchQuery, setTokenSearchQuery] = useState("");
  const [flightRadarSearchQuery, setFlightRadarSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "created_at",
    direction: "desc",
  });

  const [tokenLogs, setTokenLogs] = useState([]);
  const [totaltokensUsed, setTotalTokensUsed] = useState(0);
  const [totalOpenAITokensUsed, setTotalOpenAITokensUsed] = useState(0);
  const [totalClaudeAITokensUsed, setTotalClaudeAITokensUsed] = useState(0);
  const [tokenFromDate, setTokenFromDate] = useState("");
  const [tokenToDate, setTokenToDate] = useState("");
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [tokenPagination, setTokenPagination] = useState({
    count: 0,
    total_pages: 0,
    next: null,
    previous: null,
  });

  const [flightRadarLogs, setFlightRadarLogs] = useState([]);
  const [flightRadarFromDate, setFlightRadarFromDate] = useState("");
  const [flightRadarToDate, setFlightRadarToDate] = useState("");
  const [flightRadarPage, setFlightRadarPage] = useState(1);
  const [flightRadarPagination, setFlightRadarPagination] = useState({
    count: 0,
    total_pages: 0,
    next: null,
    previous: null,
  });
  const [totalFlightRadarCreditsUsed, setTotalFlightRadarCreditsUsed] = useState(0);
  const [totalFlightRadarCreditsUsedPercentage, setTotalFlightRadarCreditsUsedPercentage] = useState(0);
  const [selectedAddOnPlan, setSelectedAddOnPlan] = useState(null);


  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getUsageColor = (percentage) => {
    if (percentage < 60) return '#28a745'; // green
    if (percentage < 90) return '#ffc107'; // yellow
    return '#dc3545'; // red
  };

  const getDisplayValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return value;
  };

  const getCurrencyPrice = (item) => {
    const amount = item?.price_in_purchased_currency ?? item?.price;
    if (amount === null || amount === undefined || amount === "") return "-";
    return `${item?.currency || ""} ${amount}`.trim();
  };

  const getUsdPrice = (price) => {
    if (price === null || price === undefined || price === "") return "-";
    return `USD ${price}`;
  };

  const selectedAddOns = Array.isArray(selectedAddOnPlan?.add_on) ? selectedAddOnPlan.add_on : [];

  const CircleProgress = ({ percentage, color }) => (
    <div
      style={{
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: `conic-gradient(${color} 0deg ${(percentage / 100) * 360}deg, #e9ecef ${(percentage / 100) * 360}deg 360deg)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '10px',
        fontWeight: 'bold',
        color: color,
      }}
    >
      <div
        style={{
          width: '45px',
          height: '45px',
          borderRadius: '50%',
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: color,
        }}
      >
        {percentage}%
      </div>
    </div>
  );

  const filteredTokenLogs = [...tokenLogs]
    .filter((log) => {
      const query = tokenSearchQuery.trim().toLowerCase();
      if (!query) return true;

      return [
        log?.model,
        log?.input_tokens,
        log?.output_tokens,
        log?.total_tokens,
        log?.created_at,
      ].some((value) =>
        String(value ?? "").toLowerCase().includes(query)
      );
    })
    .sort((a, b) => {
      const aValue = a?.[sortConfig.key];
      const bValue = b?.[sortConfig.key];

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      const aDate = Date.parse(aValue);
      const bDate = Date.parse(bValue);
      if (!Number.isNaN(aDate) && !Number.isNaN(bDate)) {
        return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
      }

      const aNumber = Number(aValue);
      const bNumber = Number(bValue);
      if (!Number.isNaN(aNumber) && !Number.isNaN(bNumber)) {
        return sortConfig.direction === "asc" ? aNumber - bNumber : bNumber - aNumber;
      }

      return sortConfig.direction === "asc"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });

  const filteredFlightRadarLogs = [...flightRadarLogs]
    .filter((log) => {
      const query = flightRadarSearchQuery.trim().toLowerCase();
      if (!query) return true;

      return [
        log?.type,
        log?.credit,
        log?.created_at,
      ].some((value) =>
        String(value ?? "").toLowerCase().includes(query)
      );
    })
    .sort((a, b) => {
      const aValue = a?.[sortConfig.key];
      const bValue = b?.[sortConfig.key];

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      const aDate = Date.parse(aValue);
      const bDate = Date.parse(bValue);
      if (!Number.isNaN(aDate) && !Number.isNaN(bDate)) {
        return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
      }

      const aNumber = Number(aValue);
      const bNumber = Number(bValue);
      if (!Number.isNaN(aNumber) && !Number.isNaN(bNumber)) {
        return sortConfig.direction === "asc" ? aNumber - bNumber : bNumber - aNumber;
      }

      return sortConfig.direction === "asc"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });


  useEffect(() => {
    const fetchUserDetails = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/user-service/user/${id}`);
        console.log("User Details:", response.data);
        setUserDetails(response.data);
        setPopupMessage("User details loaded successfully");
      } catch (error) {
        console.error("Error fetching user details:", error);
        setPopupMessage("Error loading user details");
      }
      setLoading(false);
    };

    fetchUserDetails()
  }, [id]);


  useEffect(() => {
    const fetchTokenLogs = async () => {
      try {
        let response;
        let params = `?page=${currentPage}`;

        if (tokenFromDate && tokenToDate) {
          params += `&from_date=${tokenFromDate}&to_date=${tokenToDate}`;
        }

        response = await api.get(`/ai-engine/admin/token-usage/${id}${params}`);

        console.log("Full Token Usage Response:", response.data);
        console.log("Results data:", response.data.results?.data);

        const logsData = Array.isArray(response.data.results?.data) ? response.data.results.data : [];
        console.log("Setting token logs:", logsData);

        setTokenLogs(logsData);
        setTokenPagination({
          count: response.data.count || 0,
          total_pages: response.data.total_pages || 0,
          next: response.data.next || null,
          previous: response.data.previous || null,
        });

        if (response.data.results) {
          setTotalTokensUsed(response.data.results.total_token_usage || 0);
          setTotalOpenAITokensUsed(response.data.results.open_ai_token_usage || 0);
          setTotalClaudeAITokensUsed(response.data.results.claude_token_usage || 0);
          setSubscriptionDetails(response.data.results.subscription_plan || {});
          console.log("Subscription Details:", response.data.results.subscription_plan);
        }
      } catch (error) {
        console.error("Error fetching token logs:", error);
      }
      // try {
      //   let subscriptionResponse = await api.get(`/user-service/subscription/user/${id}`);
      //   console.log("Subscription Details:", subscriptionResponse.data);
      //   // setSubscriptionDetails(subscriptionResponse.data || {});
      // } catch (error) {
      //   console.error("Error fetching subscription details:", error);
      // }
    };

    fetchTokenLogs();
  }, [id, tokenFromDate, tokenToDate, currentPage]);

  useEffect(() => {
    const fetchFlightRadarLogs = async () => {
      try {
        let params = `?page=${flightRadarPage}`;

        if (flightRadarFromDate && flightRadarToDate) {
          params += `&from_date=${flightRadarFromDate}&to_date=${flightRadarToDate}`;
        }

        const response = await api.get(`/airplane-service/admin/flight-radar-credit/${id}${params}`);
        console.log("Flight Radar Credit Response:", response.data);

        const logsData = Array.isArray(response.data.results?.data) ? response.data.results.data : [];
        setFlightRadarLogs(logsData);
        setFlightRadarPagination({
          count: response.data.count || 0,
          total_pages: response.data.total_pages || 0,
          next: response.data.next || null,
          previous: response.data.previous || null,
        });

        const totalCredits = response.data.results?.total_credits || 0;
        setTotalFlightRadarCreditsUsed(totalCredits);

        const totalPercentage = response.data.results?.usage_percentage || 0;
        setTotalFlightRadarCreditsUsedPercentage(totalPercentage);
      } catch (error) {
        console.error("Error fetching flight radar logs:", error);
      }
    };

    fetchFlightRadarLogs();
  }, [id, flightRadarFromDate, flightRadarToDate, flightRadarPage]);

  useEffect(() => {
    if (!selectedAddOnPlan) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [selectedAddOnPlan]);





  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      {selectedAddOnPlan && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Add-on Plans - {selectedAddOnPlan.name || selectedAddOnPlan.product_id || "Subscription"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setSelectedAddOnPlan(null)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="table-blk table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>SNo</th>
                        <th>Platform</th>
                        <th>Type</th>
                        <th>Purchase Date</th>
                        <th>Token</th>
                        <th>Credit</th>
                        <th>Purchased Currency Price</th>
                        <th>Original Price</th>
                        <th>Tax Percentage</th>
                        <th>Tax Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedAddOns.map((addOn, addOnIndex) => (
                        <tr key={addOn.id || addOnIndex}>
                          <td>{addOnIndex + 1}</td>
                          <td className="text-uppercase">{getDisplayValue(addOn.platform)}</td>
                          <td className="text-uppercase">
                            {addOn.type ? addOn.type.replace(/_/g, " ") : "-"}
                          </td>
                          <td>{getDisplayValue(addOn.purchase_date)} (UTC)</td>
                          <td>{getDisplayValue(addOn.token)}</td>
                          <td>{getDisplayValue(addOn.credit)}</td>
                          <td>{getCurrencyPrice(addOn)}</td>
                          <td>{getUsdPrice(addOn.price)}</td>
                          <td>{getDisplayValue(addOn.tax_percentage)} %</td>
                          <td>{getDisplayValue(addOn.tax_amount)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setSelectedAddOnPlan(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <nav className="breadcrumb_nav">
                          <ul className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                              <a href="dashboard.html">Dashboard</a>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/user">User Management</Link>
                            </li>
                            <li className="breadcrumb-item text-capitalize">User Detail</li>
                          </ul>
                        </nav>
                        <h1>User Detail</h1>
                      </div>
                    </div>
                  </div>
                  <div className="outline_tab_card mt-4">
                    <nav>
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className="nav-link active"
                          id="nav-1-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-1"
                          type="button"
                          role="tab"
                          aria-controls="nav-1"
                          aria-selected="true"
                        >
                          User Details
                        </button>
                        <button
                          className="nav-link"
                          id="nav-2-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-2"
                          type="button"
                          role="tab"
                          aria-controls="nav-2"
                          aria-selected="false"
                        >
                          Subscription
                        </button>

                        <button
                          className="nav-link"
                          id="nav-3-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-3"
                          type="button"
                          role="tab"
                          aria-controls="nav-3"
                          aria-selected="false"
                        >
                          Wilco Token Logs
                        </button>

                        <button
                          className="nav-link"
                          id="nav-4-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-4"
                          type="button"
                          role="tab"
                          aria-controls="nav-4"
                          aria-selected="false"
                        >
                          Flight Radar 24 Logs
                        </button>

                      </div>
                    </nav>
                  </div>
                  {loading ? 
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  : <>
                    <div className="tab_blk">
                      <div className="tab-content" id="nav-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="nav-1"
                          role="tabpanel"
                          aria-labelledby="nav-1-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>User Profile</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_card user_profile_card common-card">
                                <div className="box_detail_blk">
                                  <div className="box_info_list">
                                    <div className="box_info_context">
                                      <p className="box_info_title">Name</p>
                                      <p className="box_info_data text-capitalize">{userDetails?.data?.first_name} {userDetails?.data?.last_name}</p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Email Address</p>
                                      <p className="box_info_data">{userDetails?.data?.email}</p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">User Role</p>
                                      <p className="box_info_data text-capitalize">{userDetails?.data?.user_type}</p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Athenticated By</p>
                                      <p className="box_info_data text-capitalize">
                                        {userDetails?.data?.auth_type}
                                      </p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Date Joined</p>
                                      <p className="box_info_data">{userDetails?.data?.created_at}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="nav-2"
                          role="tabpanel"
                          aria-labelledby="nav-2-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Subscription Details</h2>
                            </div>
                            {/* upcoming  subscription*/}
                            {userDetails?.upcoming_subscription?.type && <>
                              <div className="common_content_blk">
                                <div
                                  className="box_card user_profile_card common-card position-relative plan_status"
                                  data-status={userDetails?.upcoming_subscription?.status}
                                >
                                  <div className="box_detail_blk">
                                    <div className="box_info_list">

                                      <div className="box_info_context">
                                        <p className="box_info_title">Platform</p>
                                        <p className="box_info_data text-uppercase">
                                          {userDetails.upcoming_subscription?.platform || "-"}
                                        </p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Status</p>
                                        <p className="box_info_data text-capitalize">
                                          {userDetails.upcoming_subscription?.status || "-"}
                                        </p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Type</p>
                                        <p className="box_info_data text-capitalize">
                                          {userDetails.upcoming_subscription?.type.replace("_", " ") || "-"}
                                        </p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Plan</p>
                                        <p className="box_info_data">
                                          Basic
                                        </p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Start Date</p>
                                        <p className="box_info_data">
                                          {userDetails.upcoming_subscription?.expiry_date || "-"} (UTC)
                                        </p>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>}
                            {/* end upcoming subscription */}
                            {userDetails?.subscription?.map((sub, index) => (
                              <div className="common_content_blk" key={sub.id || index}>
                                <div className="box_card user_profile_card common-card position-relative plan_status" data-status={sub.status}>
                                  <div className="box_detail_blk">
                                    <div className="box_info_list">
                                      <div className="box_info_context">
                                        <p className="box_info_title">platform</p>
                                        <p className="box_info_data text-uppercase">{sub.platform} </p>
                                      </div>
                                      <div className="box_info_context">
                                        <p className="box_info_title">Plan</p>
                                        <p className="box_info_data">{sub.name ? sub.name : sub.product_id}</p>
                                      </div>
                                      <div className="box_info_context">
                                        <p className="box_info_title">Type</p>
                                        <p className="box_info_data text-uppercase">{sub.type ? sub.type.replace("_", " ") : "-"}</p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Start Date</p>
                                        <p className="box_info_data text-capitalize">{sub.start_date} (UTC)</p>
                                      </div>
                                      <div className="box_info_context">
                                        <p className="box_info_title">Expiry Date</p>
                                        <p className="box_info_data text-capitalize">
                                          {sub.expiry_date} (UTC)
                                        </p>
                                      </div>
                                      {sub.cancellation_date &&
                                        <div className="box_info_context">
                                          <p className="box_info_title">Cancellation Date</p>
                                          <p className="box_info_data text-capitalize text-danger">
                                            {sub.cancellation_date} (UTC)
                                          </p>
                                        </div>

                                      }

                                      <div className="box_info_context">
                                        <p className="box_info_title"> Purchased Currency Price</p>
                                        <p className="box_info_data">{sub.currency} {sub.price_in_purchased_currency ? sub.price_in_purchased_currency : sub.price}</p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Original Price</p>
                                        <p className="box_info_data text-capitalize">
                                          USD {sub.price}
                                        </p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Tax Percentage</p>
                                        <p className="box_info_data text-capitalize">
                                          {sub.tax_percentage} %
                                        </p>
                                      </div>

                                      <div className="box_info_context">
                                        <p className="box_info_title">Tax Amount</p>
                                        <p className="box_info_data text-capitalize">
                                          {sub.tax_amount}
                                        </p>
                                      </div>

                                      {/* {Array.isArray(sub.add_on) && sub.add_on.length > 0 && (
                                        <div className="box_info_context">
                                          <p className="box_info_title">Add-on Plans</p>
                                          <p className="box_info_data">
                                            <button
                                              type="button"
                                              className="primary-btn rounded-pill"
                                              onClick={() => setSelectedAddOnPlan(sub)}
                                            >
                                              View Add-ons ({sub.add_on.length})
                                            </button>
                                          </p>
                                        </div>
                                      )} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          </div>
                        </div>


                        <div
                          className="tab-pane fade"
                          id="nav-3"
                          role="tabpanel"
                          aria-labelledby="nav-3-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Wilco Token Logs Details</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_car-card">
                                <div className="box_detail_blk">
                                  <div className="common-table-wrapp-4">
                                    <div className="common-table-filter-wrapper d-flex justify-content-between align-items-start flex-wrap">
                                      <div className="common-left-blk me-3" style={{ minWidth: "240px", flexGrow: 1 }}>
                                        <div className="mb-0">
                                          <h4>Current  Subscription</h4>
                                          {subscriptionDetails.name ? <>
                                            <p className="box_info_title mb-1 text-capitalize">Current Plan : {subscriptionDetails.name} </p>
                                            {/* <p className="box_info_title mb-1">From {subscriptionDetails.data.start_date?.split(/[T ]/)[0]} to {subscriptionDetails.data.expiry_date?.split(/[T ]/)[0]}</p> */}
                                            <p className="box_info_title mb-1">From {subscriptionDetails.start_date} to {subscriptionDetails.expiry_date}</p>
                                            <p className="box_info_title mb-1">Total Limit: {subscriptionDetails.total_token}</p>
                                            {/* <p className="box_info_title mb-1" >Token  Usage : <span style={{ color: getUsageColor(subscriptionDetails.usage_percentage || 0), fontWeight: 'bold' }}>{subscriptionDetails.usage_percentage || 0}%</span> </p> */}

                                            <div style={{ marginTop: '10px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start' }}>
                                              <p className="box_info_title mb-0">Token Usage:</p>

                                              <CircleProgress
                                                percentage={subscriptionDetails.usage_percentage || 0}
                                                color={getUsageColor(subscriptionDetails.usage_percentage || 0)}
                                              />
                                            </div>
                                          </>
                                            :
                                            <p className="box_info_title mb-1">No active subscription</p>
                                          }

                                          <br />


                                          <h4> Usage</h4>
                                          <p className="box_info_title mb-1">Total OpenAI tokens: {totalOpenAITokensUsed}</p>
                                          <p className="box_info_title mb-1">Total ClaudeAI tokens: {totalClaudeAITokensUsed}</p>
                                          <p className="box_info_title mb-0">Total tokens: {totaltokensUsed}</p>



                                        </div>
                                      </div>
                                      <div className="common-right-blk d-flex flex-wrap gap-2 align-items-end justify-content-end" style={{ minWidth: "320px" }}>
                                        <div className="form-group mb-0" style={{ minWidth: "150px" }}>
                                          <label className="form-label small text-muted">From</label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="from_date"
                                            value={tokenFromDate}
                                            onChange={(e) => setTokenFromDate(e.target.value)}
                                            max={new Date().toISOString().split(/[T ]/)[0]}
                                          />
                                        </div>
                                        <div className="form-group mb-0" style={{ minWidth: "150px" }}>
                                          <label className="form-label small text-muted">To</label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="to_date"
                                            value={tokenToDate}
                                            onChange={(e) => setTokenToDate(e.target.value)}
                                            max={new Date().toISOString().split(/[T ]/)[0]}
                                          />
                                        </div>
                                        <div className="common-search-blk mb-0" style={{ minWidth: "220px" }}>
                                          <input
                                            type="search"
                                            className="form-control"
                                            placeholder="Search logs"
                                            value={tokenSearchQuery}
                                            onChange={(e) => setTokenSearchQuery(e.target.value)}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="table-blk table-responsive">
                                      <table className="table table-hover">
                                        <thead>
                                          <tr>
                                            <th>SNo</th>
                                            <th onClick={() => handleSort('model')} style={{ cursor: 'pointer' }}>
                                              Model {sortConfig.key === 'model' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('input_tokens')} style={{ cursor: 'pointer' }}>
                                              Input {sortConfig.key === 'input_tokens' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('output_tokens')} style={{ cursor: 'pointer' }}>
                                              Output {sortConfig.key === 'output_tokens' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('total_tokens')} style={{ cursor: 'pointer' }}>
                                              Total {sortConfig.key === 'total_tokens' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('created_at')} style={{ cursor: 'pointer' }}>
                                              Date {sortConfig.key === 'created_at' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {filteredTokenLogs.length > 0 ? (
                                            filteredTokenLogs.map((log, index) => (
                                              <tr key={index}>
                                                <td className="text-capitalize">{index + 1}</td>
                                                <td>{log.model}</td>
                                                <td>{log.input_tokens}</td>
                                                <td>{log.output_tokens}</td>
                                                <td>{log.total_tokens}</td>
                                                <td>{log.created_at}</td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="6" className="text-center">No tokens usages found</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    <TableFooter
                                      pagination={tokenPagination}
                                      currentPage={currentPage}
                                      setCurrentPage={setCurrentPage}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        {/* flight radar credit */}
                        <div
                          className="tab-pane fade"
                          id="nav-4"
                          role="tabpanel"
                          aria-labelledby="nav-4-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Flight Radar 24 Logs Details</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_car-card">
                                <div className="box_detail_blk">
                                  <div className="common-table-wrapp-4">
                                    <div className="common-table-filter-wrapper d-flex justify-content-between align-items-start flex-wrap">
                                      <div className="common-left-blk me-3" style={{ minWidth: "240px", flexGrow: 1 }}>
                                        <div className="mb-0">
                                          <h4>Current  Subscription</h4>
                                          {subscriptionDetails.name ? <>
                                            <p className="box_info_title mb-1 text-capitalize">Current Plan : {subscriptionDetails.name} </p>
                                            <p className="box_info_title mb-1">From {subscriptionDetails.start_date} to {subscriptionDetails.expiry_date}</p>
                                            <p className="box_info_title mb-1">Total Credit Limit: {subscriptionDetails.total_credit}</p>
                                            <div style={{ marginTop: '10px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start' }}>
                                              <p className="box_info_title mb-0">Credit Usage:</p>

                                              <CircleProgress
                                                percentage={totalFlightRadarCreditsUsedPercentage}
                                                color={getUsageColor(totalFlightRadarCreditsUsedPercentage)}
                                              />
                                            </div>
                                          </>
                                            :
                                            <p className="box_info_title mb-1">No active subscription</p>
                                          }

                                          <br />

                                          <h4> Usage</h4>
                                          <p className="box_info_title mb-0">Total Credits: {totalFlightRadarCreditsUsed}</p>

                                        </div>
                                      </div>
                                      <div className="common-right-blk d-flex flex-wrap gap-2 align-items-end justify-content-end" style={{ minWidth: "320px" }}>
                                        <div className="form-group mb-0" style={{ minWidth: "150px" }}>
                                          <label className="form-label small text-muted">From</label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="from_date"
                                            value={flightRadarFromDate}
                                            onChange={(e) => setFlightRadarFromDate(e.target.value)}
                                            max={new Date().toISOString().split(/[T ]/)[0]}
                                          />
                                        </div>
                                        <div className="form-group mb-0" style={{ minWidth: "150px" }}>
                                          <label className="form-label small text-muted">To</label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="to_date"
                                            value={flightRadarToDate}
                                            onChange={(e) => setFlightRadarToDate(e.target.value)}
                                            max={new Date().toISOString().split(/[T ]/)[0]}
                                          />
                                        </div>
                                        <div className="common-search-blk mb-0" style={{ minWidth: "220px" }}>
                                          <input
                                            type="search"
                                            className="form-control"
                                            placeholder="Search logs"
                                            value={flightRadarSearchQuery}
                                            onChange={(e) => setFlightRadarSearchQuery(e.target.value)}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="table-blk table-responsive">
                                      <table className="table table-hover">
                                        <thead>
                                          <tr>
                                            <th>SNo</th>
                                            <th onClick={() => handleSort('type')} style={{ cursor: 'pointer' }}>
                                              Type {sortConfig.key === 'type' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('credit')} style={{ cursor: 'pointer' }}>
                                              Credit {sortConfig.key === 'credit' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('created_at')} style={{ cursor: 'pointer' }}>
                                              Date {sortConfig.key === 'created_at' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {filteredFlightRadarLogs.length > 0 ? (
                                            filteredFlightRadarLogs.map((log, index) => (
                                              <tr key={log.id || index}>
                                                <td className="text-capitalize">{index + 1}</td>
                                                <td>{log.type}</td>
                                                <td>{log.credit}</td>
                                                <td>{log.created_at}</td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="4" className="text-center">No flight radar credits found</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    <TableFooter
                                      pagination={flightRadarPagination}
                                      currentPage={flightRadarPage}
                                      setCurrentPage={setFlightRadarPage}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        {/* end flight radar credit */}
                      </div>
                    </div>
                  </>}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default UserDetails;
